export enum AdminVenue {
  district = "district",
  school = "school",
}
